module.exports = __webpack_public_path__ + "img/cancer.bfc0719a.svg";